var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canPlayLeaderboardMusic)?_c('audio',{ref:"leaderboard-music",attrs:{"src":_vm.leaderboardMusic,"autoplay":true,"preload":"auto"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }